import { Vinyl } from "./game/Vinyl.js";

/**
 * The mark: the record, lit.
 *
 * It is the same `Vinyl` the board plays with and the same shape the home-screen
 * icons were drawn from — so the thing on the launcher, the thing spinning
 * during a clip, and the thing at the top of the front door are one object,
 * rather than three drawings of a record that drift apart.
 *
 * The glow is a sibling element rather than a `filter` on the SVG: a filter
 * would blur the grooves along with the halo, and the grooves are the only
 * reason it reads as a record instead of a disc.
 */
export function Logo({ size = 112 }: { size?: number }) {
  return (
    <div className="relative inline-flex items-center justify-center" aria-hidden="true">
      {/* The halo. Sized off the mark so one number changes both. */}
      <span
        className="absolute rounded-full bg-flash-500/25 blur-2xl"
        style={{ width: size * 0.9, height: size * 0.9 }}
      />
      <span
        className="absolute rounded-full bg-ramp-4/20 blur-3xl"
        style={{ width: size * 1.15, height: size * 1.15 }}
      />
      <Vinyl
        size={size}
        className="relative drop-shadow-[0_8px_24px_rgba(157,123,255,0.35)]"
      />
    </div>
  );
}
